import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const [activeTab, setActiveTab] = useState('operator');

  return (
    <div className="services">
      <section className="services-hero section">
        <div className="container">
          <h1 className="page-title">Cable TV Services</h1>
          <p className="page-subtitle">
            Comprehensive solutions for cable TV operators and customers
          </p>
        </div>
      </section>

      <section className="services-tabs section">
        <div className="container">
          <div className="tab-buttons">
            <button 
              className={`tab-btn ${activeTab === 'operator' ? 'active' : ''}`}
              onClick={() => setActiveTab('operator')}
            >
              Operator App
            </button>
            <button 
              className={`tab-btn ${activeTab === 'customer' ? 'active' : ''}`}
              onClick={() => setActiveTab('customer')}
            >
              Customer App
            </button>
            <button 
              className={`tab-btn ${activeTab === 'agent' ? 'active' : ''}`}
              onClick={() => setActiveTab('agent')}
            >
              Collection Agent App
            </button>
          </div>

          {activeTab === 'operator' && (
            <div className="tab-content">
              <h2 className="tab-title">Local Cable Operators</h2>
              <p className="tab-description">
                Complete billing and management solution designed specifically for cable TV operators
              </p>
              <div className="services-grid">
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">⚙️</div>
                  </div>
                  <h3>Plan Management</h3>
                  <p>Create, edit, and manage multiple subscription plans with flexible pricing options. Set up different packages for various customer segments.</p>
                  <ul className="service-features">
                    <li>Multiple plan configurations</li>
                    <li>Flexible pricing models</li>
                    <li>Package customization</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">👥</div>
                  </div>
                  <h3>Customer/Subscriber Management</h3>
                  <p>Comprehensive database to manage all your subscribers. Track customer details, subscription history, and payment records.</p>
                  <ul className="service-features">
                    <li>Customer database</li>
                    <li>Subscription tracking</li>
                    <li>Payment history</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">📊</div>
                  </div>
                  <h3>Daily/Weekly/Monthly Reports</h3>
                  <p>Generate detailed reports for better business insights. Track revenue, collections, and customer analytics.</p>
                  <ul className="service-features">
                    <li>Revenue reports</li>
                    <li>Collection reports</li>
                    <li>Customer analytics</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">📺</div>
                  </div>
                  <h3>Customer Running Packages</h3>
                  <p>Monitor active customer packages and subscription status in real-time. Manage renewals and upgrades seamlessly.</p>
                  <ul className="service-features">
                    <li>Real-time status tracking</li>
                    <li>Package renewals</li>
                    <li>Upgrade management</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">📡</div>
                  </div>
                  <h3>Broadcaster Bouquet Selection</h3>
                  <p>Select and manage broadcaster bouquets with integrated online payment system for seamless transactions.</p>
                  <ul className="service-features">
                    <li>Bouquet management</li>
                    <li>Online payments</li>
                    <li>Transaction tracking</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">📱</div>
                  </div>
                  <h3>Collection & Service Agent Management</h3>
                  <p>Mobile app for collection and service agents to manage operations on the go. Track agent performance and collections.</p>
                  <ul className="service-features">
                    <li>Agent mobile app</li>
                    <li>Performance tracking</li>
                    <li>Collection management</li>
                  </ul>
                </div>
              </div>
              <div className="service-cta">
                <p className="cta-text">
                  The completeness of this product with all required reports is phenomenal.
                </p>
                <div className="cta-buttons">
                  <Link to="/plans" className="btn btn-primary">
                    View Plans
                  </Link>
                  <Link to="/contact" className="btn btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'customer' && (
            <div className="tab-content">
              <h2 className="tab-title">Customer App</h2>
              <p className="tab-description">
                The best available companion for your Cable TV with range of functionalities
              </p>
              <div className="services-grid">
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">📋</div>
                  </div>
                  <h3>Plan Management</h3>
                  <p>View and manage your cable TV plans with ease. Switch between packages anytime from the app.</p>
                  <ul className="service-features">
                    <li>View current plans</li>
                    <li>Switch packages</li>
                    <li>Plan comparison</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">📞</div>
                  </div>
                  <h3>Complain Tracker</h3>
                  <p>Track your complaints in real-time. Get instant updates on service requests and their resolution status.</p>
                  <ul className="service-features">
                    <li>Real-time tracking</li>
                    <li>Status updates</li>
                    <li>History view</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">💳</div>
                  </div>
                  <h3>Online Bill Payment</h3>
                  <p>Pay your bills securely online with multiple payment options. Get instant payment confirmation and receipts.</p>
                  <ul className="service-features">
                    <li>Multiple payment methods</li>
                    <li>Secure transactions</li>
                    <li>Instant receipts</li>
                  </ul>
                </div>
                <div className="service-card">
                  <div className="service-icon-wrapper">
                    <div className="service-icon">🚨</div>
                  </div>
                  <h3>Complain Raise Option</h3>
                  <p>Raise service complaints directly from the app. Quick and easy resolution with automated ticketing system.</p>
                  <ul className="service-features">
                    <li>Easy complaint submission</li>
                    <li>Automated ticketing</li>
                    <li>Quick resolution</li>
                  </ul>
                </div>
              </div>
              <div className="service-cta">
                <div className="cta-buttons">
                  <Link to="/register" className="btn btn-primary">
                    Download App
                  </Link>
                  <Link to="/contact" className="btn btn-outline">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'agent' && (
            <div className="tab-content">
              <h2 className="tab-title">Collection Agent App</h2>
              <p className="tab-description">
                Streamline collection operations with our powerful mobile application
              </p>
              <div className="workflow-steps">
                <div className="workflow-step-large">
                  <div className="step-number-large">1</div>
                  <div className="step-content-large">
                    <h3>Cable TV Customer Request</h3>
                    <p className="quote">"Can you come tomorrow to collect the cable TV bill sir?"</p>
                    <p>Customers can request collection agents through the app or phone call.</p>
                  </div>
                </div>
                <div className="workflow-step-large">
                  <div className="step-number-large">2</div>
                  <div className="step-content-large">
                    <h3>Collection Agent Response</h3>
                    <p className="quote">"You can pay online using customer app or Pay cash at nearest collection point mam"</p>
                    <p>Agents can guide customers to pay online or visit collection points.</p>
                  </div>
                </div>
                <div className="workflow-step-large">
                  <div className="step-number-large">3</div>
                  <div className="step-content-large">
                    <h3>Payment Received</h3>
                    <p className="quote">Payment confirmed and receipt generated</p>
                    <p>Instant confirmation and digital receipt generation for all transactions.</p>
                  </div>
                </div>
              </div>
              <div className="agent-features">
                <h3>Key Features for Collection Agents</h3>
                <div className="features-list">
                  <div className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>Track collection targets and performance</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>Manage customer payments on the go</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>Generate receipts instantly</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>View customer payment history</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check">✓</span>
                    <span>Sync data in real-time</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Services;

